import { ScrBaseResponse, ScrMessage } from "../services/base.service";
import { Field, ObjectType } from "./decorators";


@ObjectType()
export class SystemMessage {
  @Field() messageId?: number;
  @Field() text?: string;
  @Field() subject?: string;
  @Field() messageType?: string;
  @Field() createTime?: Date;
  @Field() updateTime?: Date;
  @Field() readByUser?: boolean;
  
  selected?: boolean;
  expanded?: boolean;
  isExpansionDisplay?: boolean;
}

export class SystemMessagesResponse extends ScrBaseResponse {

  public systemMessages?: SystemMessage[];
  public count?: number;

  constructor(status: string, messages: ScrMessage[]) {
    super(status, messages);
  }

}
